<template>
  <div class="minheight100" style="padding-bottom: 130px" v-if="type">
    <template v-if="url && type === 1">
      <iframe class="m-iframe" :src="url" frameborder="0"></iframe>
    </template>
    <template v-else>
      <app-header v-if="appUser.isNative" back-type="back-app" title="友邻少年"></app-header>
      <div class="imgmax">
        <img src="https://img-cdn1.ylyk.com/image/1696926838252_m1696848927817_s1521412.jpg" />
      </div>

      <div class="foot">
        <div class="footer">
          <p class="price">
            <span class="shop-price-integral">
              <span>¥0.00</span>
            </span>
          </p>
          <button class="btn" @click="signUp()">立即报名</button>
        </div>
      </div>
    </template>
    <!-- <div class="fixed-bottom" style="padding: 0.18rem 0.47rem;">
      <div class="fixed-bottom-flex">
        <div class="fixed-bottom-price">¥0.00</div>
        <div class="btn-common" @click="signUp()">
          
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import Body from '@/mixins/body'
import { appUser } from '@/utils'
import { activityService } from '@/api'
const action = 'vipActivity'

export default {
  name: 'vipActivity',
  mixins: [Body],
  components: {},
  data() {
    return { appUser, url: '', type: 0 }
  },
  computed: {},
  watch: {},
  created() {
    if (this.hasUser()) {
      this.signUp('camp')
    }
  },
  mounted() {},
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      // this.signUp()
    },
    signUp(type) {
      activityService.isVipActivity().then(res => {
        let isTestEnv =
          process.env.NODE_ENV !== 'production' ||
          location.href.indexOf('ylyk-test.com') > 0 ||
          location.href.indexOf('ylyk.com/test/') > 0
        let url = isTestEnv ? 'https://stest.ylyk.com/s/y2MR7z' : 'https://s.ylyk.com/s/eiQr22'
        if (type) {
          if (type === res.goType) {
            // this.$router.push({ path: 'goods', query: { goodsId: '104305' } })
            // location.href = 'https://s.ylyk.com/s/eiQr22'
            this.url = url
            this.type = 1
          } else {
            this.type = 2
          }
          return
        }
        this.type = 2
        switch (res.goType) {
          case 'vip':
            this.$toast('敬请期待')
            // this.$router.push({ path: 'vipGroup' })
            break
          case 'foreverVip':
            this.$router.push({ path: 'foreverVip' })
            break
          case 'camp':
            // this.$router.push({ path: 'goods', query: { goodsId: 104305 } })
            // location.href = 'https://s.ylyk.com/s/eiQr22'
            this.url = url
            this.type = 1
            break
          default:
            break
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.m-iframe {
  width: 100%;
  min-height: 100vh;
}
.foot {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  border-top: 1px solid #eeeeee;
  // iphoneX only
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  .footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.18rem 0.47rem;
    border-top: none !important;
    background-color: #fff;
    .price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .shop-price-integral {
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 0.54rem;
        span {
          color: #00b25a;
        }
      }
      .shop-price {
        font-size: 0.44rem;
        color: #00b25a;
        font-weight: bold;
        line-height: 0.54rem;
      }
      .original-price {
        color: #999999;
        font-size: 0.26rem;
        line-height: 0.32rem;
        margin-top: 0.1rem;
      }
    }
    .btn {
      padding: 0.24rem 0.4rem;
      background-color: #00b25a;
      border-radius: 0.12rem;
      color: #fff;
    }
    .btn-click-disable {
      pointer-events: none;
      background-color: #bbbbbb;
      max-width: 3rem;
      font-size: 0.28rem;
      text-align: center;
    }
  }
}
</style>
